export default "__VITE_ASSET__B12WuROZ__"